module.exports = __webpack_public_path__ + "static/img/cc.d2f8175a.png";